import styled from "styled-components";
import {
  ActiveTradePreviewStyles,
  BotPreviewCardStyles,
} from "@shared/features/bots/styles";
import Title from "common/Typography/Title";
import { phoneMaxWidth } from "common/NewLook/layout.ts";

export const BotCardSectionWrapper = styled.div<{ $isMobile?: boolean }>`
  ${BotPreviewCardStyles.sectionWrapper};
  border-top: ${(p) => p.theme.borders.medium};
  &:last-child {
    padding-bottom: 0;
  }
`;

export const BotCardPropertyRow = styled.div<{ $isMobile?: boolean }>`
  ${BotPreviewCardStyles.propertyRow};
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
  @media (max-width: ${phoneMaxWidth}) {
    padding: 6px 0;
  }
`;

export const BottomRowWrapper = styled.div<{
  $useActiveTradeRows?: boolean;
}>`
  ${ActiveTradePreviewStyles.statisticsWrapper};
  margin-top: 8px;
`;

export const StatisticWrapper = styled.div<{
  $useActiveTradeRows?: boolean;
  $hideBorder?: boolean;
}>`
  ${ActiveTradePreviewStyles.statisticWrapper};
  ${(p) =>
    !p.$hideBorder &&
    `
    &:not(:last-of-type) {
      border-right: ${p.theme.borders.medium};
    }
  `};
`;

export const StatisticTitle = styled(Title).attrs({
  level: 5,
  type: "secondary",
})`
  font-size: 12px;
  padding: 0 4px;
  text-align: center;
`;
